const GB = 1e9;
const MB = 1e6;
const KB = 1e3;

/** "6.9 GB" / "0.4 GB" / "67.0 MB" / "16 KB" — decimal units; GB from 100 MB so sizes compare at a glance, KB below 0.1 MB. */
export function formatBytes(bytes: number | null): string {
  if (bytes === null) return '?';
  if (bytes >= 100 * MB) return `${(bytes / GB).toFixed(1)} GB`;
  return bytes >= 100 * KB ? `${(bytes / MB).toFixed(1)} MB` : `${Math.round(bytes / KB)} KB`;
}

export function percent(received: number, total: number | null): number | null {
  return total ? Math.min(100, Math.round((received / total) * 100)) : null;
}

export const OUTDATED_AGENT = /update the couch agent/i;
